import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (params) {
  const { isRequestSuccessed, exec, rst } = useRequest({
    url: '',
    name: 'SHUTDOWN_REASON_RECORD_DELETE',
    method: 'DELETE',
  });
  useEffect(() => {
    if (params) {
      let url = '/api/shutdown/reason/record/' + params.id + '?lotslog_id=' + params.lotslog_id;
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [isRequestSuccessed, rst];
});
